import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, CircularProgress } from '@material-ui/core';

import Checkbox from '../../../componentes/Checkbox';
import { Container, Content, Text, Title, Subtitle } from '../../../componentes/Interface';
import { get } from '../../../_axios/requisicao';
import { IStoreRedux } from 'Types/Reducers';

export default function EscolhaDeVoluntariado({ perfis }: any) {
  const { hash, referencia, idPessoa } = useSelector<IStoreRedux, IStoreRedux['app']>(state => state.app);
  const perfisVoluntariado = useSelector<IStoreRedux, number[]>(state => state.voluntario.perfisVoluntariado || []);
  const dispatch = useDispatch();

  const historicoNavegacao = useHistory();
  const codigoReferencia = hash ? hash.substring(0, 6) : referencia

  const [httpStatus, setHttpStatus] = useState(0);

	useEffect(() => void dispatch({ type: 'ALTERA_ETAPA_ATUAL', etapaAtual: 'escolha-voluntariado' }), [dispatch]);

  useEffect(() => {
    if (!idPessoa || !codigoReferencia) return;

    async function obtemUrlVoluntario() {
      try {
        const retorno = await get(
          'api-pessoas',
          `/pessoas/${idPessoa}/tornar-voluntario/${codigoReferencia}`,
          { referencia: codigoReferencia }
        );
        dispatch({ type: 'ALTERA_URL_VOLUNTARIADO', urlVoluntariado: retorno.data.url });
      } catch (error) {
        setHttpStatus(500);
      }
    }

    // TODO: criar state para carregando ao invés dessa gambis.
    obtemUrlVoluntario()
			.then(() => setHttpStatus(200), () => setHttpStatus(500))
  }, [historicoNavegacao, idPessoa, codigoReferencia, dispatch]);

  function alteraPerfisSelecionados(event: any) {
    const checked = event.target.checked;
    const value = event.target.value;

    if (checked && !perfisVoluntariado.includes(value))
      dispatch({ type: 'ALTERA_PERFIS_VOLUNTARIADO', perfisVoluntariado: [...perfisVoluntariado, value] });
    else if (!checked && perfisVoluntariado.includes(value))
      dispatch({ type: 'ALTERA_PERFIS_VOLUNTARIADO', perfisVoluntariado: perfisVoluntariado.filter(idPerfil => idPerfil !== value) });
  }

  useEffect(() => void dispatch({ type: 'VALIDA_ETAPA', etapaValida: perfisVoluntariado.length > 0 }), [dispatch, perfisVoluntariado.length]);

  function obterOpcoesCheckbox() {
    const opcoes = perfis
      // .filter(perfil => perfisPermitidos.includes(perfil.idPerfil))
      .map((perfil: any) => (
        <Checkbox
          gutterBottom
          key={perfil.idperfil}
          rotulo={<Text>{perfil.descricao}</Text>}
          value={perfil.idperfil}
          onChange={alteraPerfisSelecionados}
        />
      ));

    return opcoes;
  }

  return (
    <>
      {/* Carregando */}
      {httpStatus === 0 &&
        <Container>
          <Content full verticalCenter horizontalCenter padding>
            <CircularProgress color='primary' size={42} />
            <br /><Subtitle>Aguarde um momento...</Subtitle>
          </Content>
        </Container>
      }

      {/* Formulario */}
      {httpStatus === 200 &&
        <div className="etapa-formulario">
          <Content full verticalCenter horizontalCenter padding>
            <Subtitle>Como você pode nos ajudar?</Subtitle>
            <Text gutterBottom light>(selecione uma ou mais opções)</Text>
            <div>{obterOpcoesCheckbox()}</div>
          </Content>
        </div>
      }

      {/* Falhou */}
      {httpStatus === 500 &&
        <Container>
          <Content full verticalCenter horizontalCenter padding>
            <Title gutterBottom>Ops...</Title>
            <Text gutterBottom align='center'>
              Parece que o servidor respondeu de forma inesperada.
            </Text>
            <br />

            <Button
              variant='outlined'
              color='inherit'
              onClick={() => window.location.reload()}>
              TENTAR NOVAMENTE
            </Button>
          </Content>
        </Container>
      }
    </>
  );
}
